<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"
        height="auto"
        :error-message="errorMessage"
        @submit="updateSmsConfiguration({type: 'sms_configuration',
         item: {'sms_sender_alias_name': sms_sender_alias_name},})"
    >
        {{ translations.smsEmailInfo[lang] }}

        <b-text-field
            :label="translations.messageSenderName[lang]"
            v-model="sms_sender_alias_name"
        ></b-text-field>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/smsConfiguration";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";

export default {
    name: "SmsConfiguration",

    mixins: [translations],
    data() {
        return {
            sms_sender_alias_name: ''
        }
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading.sms_configuration;
        },

        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .sms_configuration;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .sms_configuration;
        },


    },
    methods: {
        ...mapActions("loyaltyPanel/businessProfile", [
            "updateSmsConfiguration"
        ]),

        getCampaignCredentials() {
            let campaign_data = this.$store.state.loyaltyPanel.businessProfile;
            this.sms_sender_alias_name = campaign_data &&  campaign_data.sms_configuration ? campaign_data.sms_configuration.sms_sender_alias_name : ""
        }
    },

    watch:{
        ["$store.state.loyaltyPanel.businessProfile.businessProfileData"]: {
            handler(val) {
                this.sms_sender_alias_name = val.sms_configuration.sms_sender_alias_name;
            }
        },
    },
    mounted() {
        this.getCampaignCredentials();
    }

};
</script>
